<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(sm12, md11, lg9, xl7, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat).centerCard
            breadcrumb(back='page10-2') 
              | Estás en: Elige tu Crédito Hipotecario / ¿Qué aprendí en esta lección?
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 2 DE 4
            img.pt-3(style="width:61px; heigth:67px;", src="assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg.text-center Existen algunas variables que debes tomar en cuenta a la hora de diseñar tu plan de Crédito Hipotecario. ¿Recuerdas en qué consisten?
            v-card-text.parrafoDestacadoB.text-center
              | Relaciona los conceptos de la columna derecha con su descripción. 
            v-layout.pb-4.ma-0(row, justify-center)
              v-flex(xs12)
                  v-layout(row, flex, align-center)
                    v-flex.px-1(xs10, text-xs-center, align-content-center)
                      v-card.py-0(flat, color='grey lighten-4 ', v-for='(reactivo, index) in reactivos ', :key='index ')
                        v-layout.my-2.text-xs-right(flat)
                          v-flex.py-0.my-0(xs11)
                            v-card-text.pregunta.text-xs-left.text-center
                              | {{reactivo.pregunta}}
                          v-flex.py-3.mr-4.ml-0(xs1, text-xs-start)
                            v-icon(size='15px', v-if='sent && (reactivos[index].resultado==0) ', color='red ') fas fa-times
                            v-icon(size='15px', v-if='sent && (reactivos[index].resultado==1) ', color='green ') fas fa-check
                    v-flex.px-1(xs2, text-xs-center, align-content-center)
                      v-card.py-0(flat v-for='(reactivo, index) in reactivos' :key='index ')
                        v-layout.my-1.text-xs-right(flat)
                          v-select.selector.py-0(v-if='show' style="margin:2px 10px;", :items='respuestas' v-model='reactivo.respuesta' label='Selecciona...' solo hide-details height='59')
          v-layout(row, justify-center)
            v-flex
              div(v-if='!sent')
                v-btn.btn(color='secondary ', :disabled='!completed', @click='sendResult() ')
                  | Enviar
              div(v-if='sent')
                v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                  | Ver Retroalimentación
                v-dialog(v-model='dialog ', persistent, max-width='930px ')
                  v-layout(row, justify-center)
                    v-flex(text-xs-center)
                      v-card
                        .pt-1.pr-2(v-if='sent && (response==1) ')
                          v-layout(row, justify-center)
                            v-flex(text-xs-center)
                              img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                          v-spacer.my-1.py-4
                          v-card-text.headline
                            | ¡Excelente!
                          v-card.questionCard(flat)
                            v-card-text.dialog_text
                              p.text-sm-left.px-5.my-0
                                | Tienes una idea muy clara de las variables que influyen en el diseño de tu plan de Crédito Hipotecario. 
                                |  Puedes repasarlas a continuación:
                                br
                                b Gastos de originación: 
                                |  Son los costos que debo considerar antes de adquirir mi Crédito Hipotecario. Incluyen: gastos notariales, pago del enganche, avalúos y comisiones por apertura.  
                                br
                                b Monto: 
                                |  Es la cantidad que me prestará el banco y depende de sus políticas internas, así como de mi capacidad de pago y mi situación crediticia. 
                                br
                                b Crédito Mancomunado: 
                                |  Es la opción que me brindan los bancos para unir mis ingresos con los de mi pareja y acceder a un monto de financiamiento mayor.  
                                br
                                b Plazo: 
                                |  Es el tiempo que elegiré para pagar mi crédito. Esta elección afectará el monto de mi mensualidad.
                                br
                                b Co-financiamiento: 
                                |  Es la opción que me brindan los bancos para sumar mis prestaciones del FOVISSTE o INFONAVIT a un Crédito Hipotecario
                        .pt-1.pr-2(v-if='sent && (response!=1) ')
                          v-layout(row, justify-center)
                            v-flex(text-xs-center)
                              img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                          v-spacer.my-1.py-4
                          v-card-text.headline
                            | Hay una mejor respuesta...
                          v-card.questionCard(flat)
                            v-card-text.dialog_text
                              p.text-sm-left.px-5.my-0
                                | ¡Estuviste cerca! A continuación, encontrarás la relación correcta:
                                br
                                b Gastos de originación: 
                                |  Son los costos que debo considerar antes de adquirir mi Crédito Hipotecario. Incluyen: gastos notariales, pago del enganche, avalúos y comisiones por apertura.  
                                br
                                b Monto: 
                                |  Es la cantidad que me prestará el banco y depende de sus políticas internas, así como de mi capacidad de pago y mi situación crediticia. 
                                br
                                b Crédito Mancomunado: 
                                |  Es la opción que me brindan los bancos para unir mis ingresos con los de mi pareja y acceder a un monto de financiamiento mayor.  
                                br
                                b Plazo: 
                                |  Es el tiempo que elegiré para pagar mi crédito. Esta elección afectará el monto de mi mensualidad.
                                br
                                b Co-financiamiento: 
                                |  Es la opción que me brindan los bancos para sumar mis prestaciones del FOVISSTE o INFONAVIT a un Crédito Hipotecario
                        v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page10-4') ")
                          | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>
<script>
import {
  eventBus
} from '../main';

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}

export default {
  name: 'app',
  deactivated() {
    this.time = 135;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if ((this.time > 0) && !this.sent) {
          this.time--
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage('p05');
          }
        }
      }, 1000)
    }
  },
  data() {
    return {
      reactivos: [{
          pregunta: 'Son los costos que debo considerar antes de adquirir mi Crédito Hipotecario. Incluyen: gastos notariales, pago del enganche, avalúos y comisiones por apertura.',
          correcta: 'Gastos de originación',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Es la cantidad que me prestará el banco y depende de sus políticas internas, así como de mi capacidad de pago y mi situación crediticia.',
          correcta: 'Monto',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Es la opción que me brindan los bancos para unir mis ingresos con los de mi pareja y acceder a un monto de financiamiento mayor.',
          correcta: 'Crédito Mancomunado',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Es el tiempo que elegiré para pagar mi Crédito. Esta elección afectará el monto de mi mensualidad.',
          correcta: 'Plazo',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Es la opción que me brindan los bancos para sumar mis prestaciones del FOVISSTE o INFONAVIT a un Crédito Hipotecario.  ',
          correcta: 'Cofinanciamiento',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        }
      ],
      respuestas: [
        "Gastos de originación",
        "Monto",
        "Crédito Mancomunado",
        "Plazo",
        "Cofinanciamiento"
      ],
      response: 'none',
      show: false,
      dialog: false,
      correcta: false,
      completo: 'none',
      sent: false,
      resultado: 0,
      time: 135,
      timer: null,
      interaction : {
        id : "TCH.L2.p10-2",
        questionText : "Clasifica en gastos fijos o variables",
        learnerResponse: "",
        correctAnswer : "",
        wasCorrect : true
      }
    }
  },
  computed: {
    completed() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == "") {
          complete = false;
        }
      });
      return complete;
    },
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  },
  beforeMount: function() {
    shuffle(this.respuestas);
  },
  beforeUpdate: function() {
    var respuestas = this.respuestas;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          respuestas.push(reactivo.respuesta.shift());
        } else {
          respuestas.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  created() {
    window.setInterval(() => {
      this.show = true;
    },2000);
  },
  methods: {
    grade: function(reactivos) {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta ==reactivo.respuesta) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('send_suspend_data', this.reactivos);
      this.response = this.resultado;
      // Record interactions
      var interaction = this.interaction;
      interaction.learnerResponse = this.reactivos.map(function (reactivo, index) {
         return (reactivo.respuesta? "Fijo":"Variable")
      });
      eventBus.$emit('record_interaction', interaction)
    },
    created() {
      if ('suspend_data' in this.$parent) {
        if (this.$parent.currentPage in this.$parent.suspend_data) {
          this.reactivos = this.$parent.suspend_data[this.$parent.currentPage];
          this.sendResult();
        }
      }
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    },
    testValueTrue(value, correct) {
      if (value == 'none') {
        return 'greyNormal'
      }
      if (value == true) {
        if (correct == 'none') {
          return 'accent';
        } else if (correct == 1) {
          return 'accent';
        } else if (correct == 0) {
          return 'red';
        }
      }
      if (value == false) {
        return 'greyNormal'
      }
    },
    testValueFalse(value, correct) {
      if (value == 'none') {
        return 'greyNormal'
      }
      if (value == false) {
        if (correct == 'none') {
          return 'accent';
        } else if (correct == 1) {
          return 'accent';
        } else if (correct == 0) {
          return 'red';
        }
      }
      if (value == true) {
        return 'greyNormal'
      }
    }
  }
};
</script>
